import React, { useEffect, useState } from "react";
import NavBar from "../../../Common/NavBar";
import { VehiculosTabla } from "./VehiculosTabla";
import { VehiculosModal } from "./VehiculosModal";
import { VehiculoCinturonesModal } from "./VehiculoCinturonesModal";
import { VehiculosURL } from "../../../API/apiurls";
import { GuardarElementos } from "../../../Hooks/CRUDHooks";
import { requestDataVehiculo } from "./requestDataVehiculo";
import Swal from "sweetalert2";
import axios from "axios";

export function Vehiculos() {
  const [datosEdit, setDatosEdit] = useState(null);
  const [vehiculoAsignacion, setVehiculoAsignacion] = useState(null);
  const [show, setShow] = useState(false);
  const [showAsignacion, setShowAsignacion] = useState(false);
  const [datos, setDatos] = useState([]);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(false);

  const handleShowModal = () => setShow(true);
  const handleCerrar = () => {
    setShow(false);
    setDatosEdit(null);
  };

  const handleCerrarAsignacion = () => {
    setShowAsignacion(false);
    setVehiculoAsignacion(null);
  };

  const cargarDatos = async (p = page, s = size) => {
    setLoading(true);
    try {
      const response = await axios.get(`${VehiculosURL}/page`, {
        params: { page: p, size: s },
      });

      setDatos(response.data.content || []);
      setTotalPages(response.data.totalPages ?? 0);
      setTotalElements(response.data.totalElements ?? 0);
      setPage(response.data.number ?? p);
      setSize(response.data.size ?? s);
    } catch (error) {
      console.error("Error al cargar los vehiculos:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarDatos(0, size);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGuardar = (dataForm) => {
    setTimeout(() => {
      Swal.fire({
        title: "Cargando...",
        timer: 400,
        timerProgressBar: true,
        didOpen: () => Swal.showLoading(),
      }).then(() => {
        const requestData = requestDataVehiculo(dataForm);

        GuardarElementos(VehiculosURL, requestData, dataForm, setDatos).then(() => {
          cargarDatos(page, size);
        });

        handleCerrar();
      });
    }, 300);
  };

  const datosAEditar = (vehiculo) => {
    setDatosEdit(vehiculo);
    setShow(true);
  };

  const datosAsignacion = (vehiculo) => {
    setVehiculoAsignacion(vehiculo);
    setShowAsignacion(true);
  };

  const handleEditar = (dato) => {
    const requestData = requestDataVehiculo(dato);

    axios
      .put(`${VehiculosURL}/${dato.id}`, requestData)
      .then(() => {
        handleCerrar();
        cargarDatos(page, size);
      })
      .catch((error) => {
        console.error("Error al editar los vehiculos:", error);
        Swal.fire("Error", "Hubo un error al editar el registro", "error");
      });
  };

  const handleConfirmDelete = (id) => {
    Swal.fire({
      title: "¿Eliminar vehículo?",
      text: "El registro se eliminará permanentemente.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      axios
        .delete(`${VehiculosURL}/${id}`)
        .then(() => {
          const isLastItemOnPage = datos.length === 1 && page > 0;
          const nextPage = isLastItemOnPage ? page - 1 : page;
          cargarDatos(nextPage, size);
        })
        .catch((error) => {
          console.error("Error al eliminar:", error);
          Swal.fire("Error", "Hubo un error al eliminar el registro", "error");
        });
    });
  };

  const handlePrev = () => {
    if (page > 0) cargarDatos(page - 1, size);
  };

  const handleNext = () => {
    if (page + 1 < totalPages) cargarDatos(page + 1, size);
  };

  return (
    <div>
      <NavBar />

      <div className="camionesMenu-contenedor admin-crud-shell">
        <VehiculosTabla
          datos={datos}
          eliminar={handleConfirmDelete}
          datosaeditar={datosAEditar}
          handleShowAsignacion={datosAsignacion}
          handleShowModal={handleShowModal}
          page={page}
          totalPages={totalPages}
          totalElements={totalElements}
          size={size}
          loading={loading}
          onPrev={handlePrev}
          onNext={handleNext}
        />
      </div>

      <VehiculosModal
        mostrar={show}
        datosaeditar={datosEdit}
        editar={handleEditar}
        cerrar={handleCerrar}
        guardar={handleGuardar}
        title={datosEdit ? "Editar vehículo" : "Nuevo vehículo"}
      />

      <VehiculoCinturonesModal
        show={showAsignacion}
        vehiculo={vehiculoAsignacion}
        onHide={handleCerrarAsignacion}
      />
    </div>
  );
}
